<div class="ui basic segment">
    <app-header
        [title]="'performance.aggregatedDataSurvey.resultsTitle' | translate: { title: survey.title }"
        [back]="true"
        [backRoute]="routeToRedirectTo"
        [menuService]="tabMenuService"
    >
        <div class="header-content margin-top-2 margin-left-1">
            <ui-info text="surveyResultsTitleTooltip"></ui-info>
        </div>
        <div class="buttons">
            <ui-button type="primary" (click)="print()">
                <mat-icon svgIcon="print"></mat-icon>
                {{ 'print' | translate }}
            </ui-button>
        </div>
    </app-header>
    <div class="app-grid">
        <form class="ui form fields printable">
            <ui-card class="chart-card" *ngFor="let chart of charts; let i = index">
                <ng-container *ngIf="chart.type === 'freeform'">
                    <div class="flex">
                        <div class="question-number">{{ i + 1 + '. ' }}</div>
                        <div class="question-text" [innerHTML]="chart.question | sanitizeHtml | translate"></div>
                    </div>

                    <ui-banner variant="info">
                        {{ 'performance.aggregatedDataSurvey.freeformQuestionResults' | translate }}
                    </ui-banner>
                </ng-container>

                <ng-container *ngIf="chart.type !== 'freeform'">
                    <div class="flex">
                        <div class="question-number">{{ i + 1 + '. ' }}</div>
                        <div class="question-text" [innerHTML]="chart.question | sanitizeHtml"></div>
                    </div>

                    <app-chart
                        [chartId]="'chart-' + i"
                        [chartData]="chart.chartData"
                        [chartOptions]="chart.chartOptions"
                        [report]="chart.chartMetaData"
                        [height]="chart.type !== 'multiple' ? 300 : 500"
                        [isPrinting]="isPrinting"
                        (getImage)="chart.chartMetaData.imageBase64 = $event"
                    ></app-chart>
                </ng-container>
            </ui-card>
        </form>
    </div>
</div>
